
import { defineComponent, ref, Ref, onMounted, onUnmounted } from "vue";
import BaseButton from "@/components/BaseButton.vue";
import { Game } from "@/game";

export default defineComponent({
  name: "Home",
  components: { BaseButton },
  setup() {
    const canvas: Ref<HTMLCanvasElement | null> = ref(null);
    let game: Game | null = null;

    onMounted(() => {
      game = new Game(canvas.value as HTMLCanvasElement, {
        speed: 20,
        level: -1,
      });
      game.autoplay();
    });

    onUnmounted(() => {
      if (game) game.stop();
    });

    return {
      canvas,
    };
  },
});
